export default "__VITE_ASSET__DBEleWOR__"